/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface CallDialogContextType {
  isCallDialogOpen: boolean;
  openCallDialog: () => void;
  closeCallDialog: () => void;
}

const CallDialogContext = createContext<CallDialogContextType | undefined>(undefined);

export const useCallDialog = () => {
  const context = useContext(CallDialogContext);
  if (context === undefined) {
    throw new Error('useCallDialog must be used within a CallDialogProvider');
  }
  return context;
};

interface CallDialogProviderProps {
  children: ReactNode;
}

export const CallDialogProvider: React.FC<CallDialogProviderProps> = ({ children }) => {
  const [isCallDialogOpen, setIsCallDialogOpen] = useState(false);

  const openCallDialog = () => setIsCallDialogOpen(true);
  const closeCallDialog = () => setIsCallDialogOpen(false);

  return (
    <CallDialogContext.Provider value={{ isCallDialogOpen, openCallDialog, closeCallDialog }}>
      {children}
    </CallDialogContext.Provider>
  );
};
